import React, { Component } from "react";
import "../../assets/bootstrap/css/bootstrap.min.css";
import "../../assets/fonts/font-awesome.min.css";
import "../../assets/css/styles.css";
import axios from "axios";
import $ from "jquery";

export class DeliverySidebar extends Component {
  constructor(props) {
    super(props);

   

    //
    // const url = 'hghobs.keshonect.co.ke'

    this.state = {
      module: "",
      profession: "",
      name: "",
      nationality: "",
      age: "",
    };

    // this.handleChange = this.handleChange.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    console.log(localStorage.getItem("accessToken"));
    console.log(localStorage.getItem("currentVisitId"));
    console.log(localStorage.getItem("currentVisitName"));
    console.log(localStorage.getItem("currentVisitNationality"));
    console.log(localStorage.getItem("currentVisitProfession"));
    console.log(localStorage.getItem("currentVisitAge"));
    this.setState({
      age: localStorage.getItem("currentVisitAge"),
      name: localStorage.getItem("currentVisitName"),
      nationality: localStorage.getItem("currentVisitNationality"),
      profession: localStorage.getItem("currentVisitProfession"),
    });

    $(".Dashboard-class").click(function (e) {
      // e.PreventDefault()
      localStorage.removeItem("currentVisitId");
      localStorage.removeItem("currentVisitName");
      localStorage.removeItem("currentVisitNationality");
      localStorage.removeItem("currentVisitProfession");
      localStorage.removeItem("currentVisitAge");
      setTimeout(function () {
        window.location.href = "/triage/init/dashboard";
      }, 500);
    });

    if (localStorage.getItem("currentVisitName")) {
      $(".patientDetails").show();
    }
    $(".close").on("click", function () {
      $(".modal").hide();
    });
    if (localStorage.getItem("accessToken") == null) {
      $("#loginFirst").show();
      // window.location.href = '/'
    }
  }
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { profession, name, nationality, age } = this.state;
    return (
      <div>
        <div className="sidebar-container">
          {/* <div className="sidebar-logo">
						Project Name
					</div> */}
          <ul className="sidebar-navigation">
            <li className="header patientDetails" style={displayHidden}>
              <h4>Patient Details</h4>
              <br />
              <b> Name: </b>
              {name}
              <br />
              <b>Nationality: </b>
              {nationality}
              <br />
              <b>Age: </b>
              {age}
              <br />
              <b>Profession: </b>
              {profession}
              <input type="hidden" value={name} className="patientName" />
            </li>
            <li>
              <a href="/delivery/general">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Delivery General
              </a>
            </li>

            <li>
              <a href="/delivery/placenta/delivery">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Placenta Delivery
              </a>
            </li>
            <li>
              <a href="/delivery/assistance/new/born">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Immediate Assistance Of The New born
              </a>
            </li>
            <li>
              <a href="/delivery/immediate/observation/mother">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Immediate Observation Of The Mother
              </a>
            </li>
            <li>
              <a href="/delivery/apgar/score">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Apgar
                Score Reanimation
              </a>
            </li>
            <li>
              <a href="/tests/to/be/done">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Tests
                To Be Done In the Lab
              </a>
            </li>
            <li>
              <a href="/send/to/module">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Send To
                Module
              </a>
            </li>

            <li>
              <a href="/ward/round">
                <i className="fa fa-plus-square" aria-hidden="true"></i> Ward
                Round
              </a>
            </li>

            <li>
              <a href="/all/modules/data">
                <i className="fa fa-plus-square" aria-hidden="true"></i> All
                Module Data
              </a>
            </li>

            <li>
              <a href="/discharge/form">
                <i className="fa fa-plus-square" aria-hidden="true"></i>{" "}
                Discharge Patient
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default DeliverySidebar;
